import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingMiscItem} from './pricing-misc-item';

@JsonObject('model.PricingMiscItemGroup')
export class PricingMiscItemGroup extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(String, 'type')
  type?: string

  @JsonProperty([PricingMiscItem], 'items')
  items?: PricingMiscItem[]

  @JsonProperty(String, 'value')
  value?: string
}

